module.exports = __webpack_public_path__ + "images/TLC_2025_Radiant_lilac_mobile.976278c7e78afc35d5a179e42eb73a0d.png";